/**
 * Whole Life LOC - Valid Fields
 *
 * Enumerates fields allowed for API filtering and persistence for Whole Life.
 * Used to validate request payloads and whitelist supported fields.
 */

import type { ValidationConfig } from "../../components/PlanEditor/validation";

/**
 * Positive validators for the four dependent benefit amount fields.
 * Works together with revertOnInvalid: true in definitions — the validator
 * catches an empty value and revertOnInvalid causes a silent revert instead
 * of a red border.
 */
export const WHOLE_LIFE_DEPENDENT_AMOUNT_VALIDATION: ValidationConfig = {
  spouseBenefitAmountAmount: ["positive"],
  spouseBenefitMaximumAmount: ["positive"],
  childBenefitAmountAmount: ["positive"],
  childBenefitMaximumAmount: ["positive"],
};

export const WHOLE_LIFE_VALID_FIELDS = new Set<string>([
  "objectType",
  "currentCarrierName",
  "coverageType",
  // Nested API objects (created by transform from flat grid fields)
  "employeeBenefitAmount",
  "employeeBenefitMaximum",
  "guaranteeIssueAmount",
  "spouseBenefitAmount",
  "spouseBenefitMaximum",
  "childBenefitAmount",
  "childBenefitMaximum",
  // Simple fields
  "ridersIncluded",
  "additionalOptionsIncluded",
  "portability",
  "interestRate",
  "endowsAge",
  "coverageEffectiveDate",
  "annualOpenEnrollment",
  "eligibilityClasses",
  "extended",
]);
